export enum GachaHistoriesPathsEnum {
  RESULTS_PAGE = "/shops/:shopId/packs/:packId/results-page/:gachaId",
}
